import {documentToPlainTextString} from '@contentful/rich-text-plain-text-renderer'
import {hpcAttrs} from '@github-ui/hpc'
import {getAnalyticsEvent} from '@github-ui/swp-core/lib/utils/analytics'
import {Button, Hero} from '@primer/react-brand/esm'

import type {GenericContent} from '../../../../../brand/lib/types/contentful'

type Props = {
  contentfulContent: GenericContent
}

export function HeroIntro({contentfulContent}: Props) {
  const {heading, subheading, label} = contentfulContent.fields

  const ctaFields = contentfulContent.fields.cta?.fields
  const genericCtaFields = ctaFields && 'primary' in ctaFields ? ctaFields : undefined
  const primaryCta = genericCtaFields?.primary
  const secondaryCta = genericCtaFields?.secondary

  return (
    <Hero {...hpcAttrs()} variant="gridline-expressive">
      {label ? <Hero.Label>{label.fields.text}</Hero.Label> : null}
      {heading ? <Hero.Heading>{heading}</Hero.Heading> : null}

      {subheading ? <Hero.Description>{documentToPlainTextString(subheading)}</Hero.Description> : null}

      <Hero.ButtonGroup>
        {primaryCta && (
          <Button
            as="a"
            href={primaryCta.fields.href}
            {...getAnalyticsEvent({
              action: primaryCta.fields.text,
              tag: 'button',
              context: 'CTAs',
              location: 'hero',
            })}
          >
            {primaryCta.fields.text}
          </Button>
        )}

        {secondaryCta ? (
          <Button
            as="a"
            href={secondaryCta.fields.href}
            {...getAnalyticsEvent({
              action: secondaryCta.fields.text,
              tag: 'button',
              context: 'CTAs',
              location: 'hero',
            })}
          >
            {secondaryCta.fields.text}
          </Button>
        ) : null}
      </Hero.ButtonGroup>
    </Hero>
  )
}
